import { z } from "zod";
import { leagueSchema } from "../schemas/index.js";
export class LeaguesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/leagues",
            endpoint: "leagues.list",
            query: { limit: params.limit, cursor: params.cursor },
            dataSchema: z.array(leagueSchema),
        });
    }
    get(id) {
        return this.http.request({
            method: "GET",
            path: `/leagues/${encodeURIComponent(id)}`,
            endpoint: "leagues.get",
            dataSchema: leagueSchema,
        });
    }
}
//# sourceMappingURL=leagues.js.map